'use client';

import { clsx } from 'clsx';
import { FC } from 'react';

import { type IconName, spriteUrl } from './sprite.generated';

export type IconSizes = {
  /** Size of the icon in pixels. Default is 24. */
  size?: 12 | 16 | 18 | 20 | 24 | 32 | 40;
};

type Props = Prettify<IconSizes & { name: IconName; 'data-testid'?: string }>;

export const Icon: FC<Props> = ({ size = 24, name, ...props }) => {
  return (
    <svg
      {...props}
      className={clsx('relative block fill-current', {
        'size-3': size === 12,
        'size-4': size === 16,
        'size-4.5': size === 18,
        'size-5': size === 20,
        'size-6': size === 24,
        'size-8': size === 32,
        'size-10': size === 40,
      })}
    >
      <use href={`${spriteUrl}#${name}`} />
    </svg>
  );
};
